import { connect } from 'react-redux'
import * as actions from '../../state/actions/services'
import { IStoreState } from 'src/types/state'
import GroupRideSettings from 'src/components/services/view/GroupRideSettings'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  const { serviceId } = ownProps
  const service = Object.values(state.service.items).find(item => item.id === serviceId)
  let groupRideInfo = null
  if (service) {
    groupRideInfo = {
      ondemandGridePickupRadius: service.ondemandGridePickupRadius,
      ondemandGrideDropoffRadius: service.ondemandGrideDropoffRadius,
      scheduledGridePickupRadius: service.scheduledGridePickupRadius,
      scheduledGrideDropoffRadius: service.scheduledGrideDropoffRadius,
      scheduledGridePickupTime: service.scheduledGridePickupTime,
      scheduledGrideDropoffTime: service.scheduledGrideDropoffTime,
      allowGroupingDifferentProducts: service.allowGroupingDifferentProducts
    }
  }

  return {
    serviceId,
    serviceSuggestedLocationList: state.service.locationList,
    groupRideInfo
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    getSuggestedLocationList: (serviceId: string): any => {
      return dispatch(actions.getSuggestedLocationList(serviceId))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupRideSettings)



// WEBPACK FOOTER //
// ./src/containers/services/ServiceViewGroupRideSettings.ts